import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Button } from "@components/ui/button";
import { Input } from "@components/ui/input";
import { IoAdd } from "react-icons/io5";
import useAuth from "@hooks/useAuth";
import { z } from "zod";
import { addDomain } from "@redux/slices/domains";
import { useNavigate } from "react-router";
import LoadingScreen from "@components/LoadingScreen";
import { ChevronLeft } from "lucide-react";
import axios from "axios";

// Define your component
const AddDomain: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();

  const navigate = useNavigate();

  const emailAccountSchema = z.object({
    domain_name: z
      .string()
      .min(1, "Email is required")
      .regex(
        /^(?!www\.|https?:\/\/)/,
        "Invalid domain. Must not start with www, http://, or https://"
      ),
  });

  type DomainFormValues = z.infer<typeof emailAccountSchema>;

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<DomainFormValues>({
    resolver: zodResolver(emailAccountSchema),
  });

  const onSubmit = async (data: DomainFormValues) => {
    setLoading(true);
    const domaindata = {
      user_id: user?.id,
      user_name: user?.first_name + " " + user.last_name || "",
      ...data,
    };

    console.log([data.domain_name]);
    await addDomain(domaindata, "Domain added successfully");

    try {
      const response = await axios.post(
        "http://localhost:5000/api/blacklist-domains",
        {
          domains: [data.domain_name],
        }
      );

      console.log("Domain added successfully:", response.data);
      // await addDomain(domaindata, "Domain added successfully");

      // navigate(`/blacklist/${user.id}`);
      // reset(); // Reset the form after submission
    } catch (error) {
      console.error("Error adding domain:", error);
    } finally {
      setLoading(false); // Turn off loading state
    }
    navigate(`/blacklist/${user.id}`);
    reset();
  };

  return (
    <div>
      {loading ? (
        <LoadingScreen />
      ) : (
        <div className="bg-white p-8">
          <h4 className="text-xl font-bold flex items-center -ms-2 mb-5">
            <ChevronLeft
              size={22}
              className="me-3 cursor-pointer"
              onClick={() => navigate(-1)}
            />
            Add Domain
          </h4>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              <p className="text-[#71717A] text-sm mb-1">Domain Name</p>
              <Input
                {...register("domain_name")}
                placeholder="Please only type in the domain name and domain ending (e.g: aquisize.de)"
              />
              {errors.domain_name && (
                <span className="text-red-600 text-sm mt-1">
                  {errors.domain_name.message}
                </span>
              )}
            </div>

            <Button className="mt-6" type="submit">
              <IoAdd size={20} className="me-2" />
              Add
            </Button>
          </form>
        </div>
      )}
    </div>
  );
};

export default AddDomain;
